import type { PropsWithChildren } from "react"
import React from "react"
import { componentStyles, useColors } from "@mallardbay/lib-react-components"

import Card from "~components/shared/card"
import Banner from "~components/shared/todo-lib-react-components/banner"

interface Props extends PropsWithChildren {
    readonly bannerMessage?: string | null
}

export default function CardWithWarningBanner({
    bannerMessage,
    children,
}: Props) {
    const styles = useStyles({ hasBannerMessage: Boolean(bannerMessage) })

    return (
        <Card style={styles.root}>
            {children}
            <Banner
                style={styles.banner}
                message={bannerMessage}
                status="warning"
            />
        </Card>
    )
}

function useStyles({ hasBannerMessage }: { hasBannerMessage: boolean }) {
    const colors = useColors()

    return componentStyles({
        root: {
            borderColor: hasBannerMessage
                ? colors.warningColor
                : colors.borderColor,
        },
        banner: {
            margin: "24px 0 -24px -24px",
            width: "calc(100% + 48px)",
            borderTopRadius: 0,
        },
    })
}
